import { render, staticRenderFns } from "./DepositModal.vue?vue&type=template&id=4b8a4d69&scoped=true"
import script from "./DepositModal.vue?vue&type=script&lang=ts"
export * from "./DepositModal.vue?vue&type=script&lang=ts"
import style0 from "./DepositModal.vue?vue&type=style&index=0&id=4b8a4d69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a4d69",
  null
  
)

export default component.exports